import { render } from "./GetFriendDashboard.vue?vue&type=template&id=58973bd5"
import script from "./GetFriendDashboard.vue?vue&type=script&lang=js"
export * from "./GetFriendDashboard.vue?vue&type=script&lang=js"

import "./GetFriendDashboard.vue?vue&type=style&index=0&id=58973bd5&lang=scss"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__